// extracted by mini-css-extract-plugin
export default {"sb-navbar":"style_sb-navbar__twg8I","tab":"style_tab__Nswpj","selected":"style_selected__qoNky"};